import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useStateValue } from "../StateProvider";
import erc20abi from "./ERC721abi.json";

function Mint() {
  const [{ global }] = useStateValue();
  const [contractListened, setContractListened] = useState();
  const [txStatus, settxStatus] = useState("");
  const [error, setError] = useState();
  const [tx, set_tx] = useState(0);
  const [contractInfo, setContractInfo] = useState({
    // address: "0xCA42aFb7D684584Cc450a4f1c9db7424b0b87480",
    address: "0x61E8ad839580b9F08eD4dd7f120F53e269576FF5",
    tokenName: "-",
    tokenSymbol: "-",
    totalSupply: "-",
    maxSupply: "-",
    cost: "-",
  });
  async function fetchTransaction(tx) {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    let txn_test = await provider.getTransactionReceipt(tx);
    if (txn_test) {
      if (txn_test.status === 0) {
        setError(1);
        set_tx(tx);
      }
    }
  }
  async function handleSubmit() {
    if (parseInt(global.networkId) === 1) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const erc20 = new ethers.Contract(
        // "0xCA42aFb7D684584Cc450a4f1c9db7424b0b87480",
        "0x61E8ad839580b9F08eD4dd7f120F53e269576FF5",
        erc20abi,
        provider
      );
      const tokenName = await erc20.name();
      const tokenSymbol = await erc20.symbol();
      const totalSupply = await erc20.totalSupply();
      const maxSupply = await erc20.maxSupply();
      let cost = await erc20.cost();
      cost = ethers.utils.formatEther(String(cost));

      setContractInfo({
        // address: "0xCA42aFb7D684584Cc450a4f1c9db7424b0b87480",
        address: "0x61E8ad839580b9F08eD4dd7f120F53e269576FF5",
        tokenName,
        tokenSymbol,
        totalSupply,
        maxSupply,
        cost,
      });
    }
  }

  useEffect(() => {
    // console.log(global.networkId, "global.networkId");
    if (parseInt(global.networkId) !== 1) {
      // console.log("a");
      setError("Change your network to Mainnet.");
      return false;
    } else if (parseInt(global.networkId) === 1) {
      // console.log("b");
      setError("");
      handleSubmit();
      if (contractInfo.address !== "-") {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const erc20 = new ethers.Contract(
          contractInfo.address,
          erc20abi,
          provider
        );
        setContractListened(erc20);
      }
    }
  }, [contractInfo, global.networkId]);

  const mintToken = async () => {
    setError("");
    settxStatus("processing");
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
    const signer = await provider.getSigner();
    const erc20 = new ethers.Contract(contractInfo.address, erc20abi, signer);
    //await erc20.mint(1, { gasLimit: 3000000, mint: "0.01 ETH" });
    await erc20
      .mint(1, {
        gasLimit: 246078,
        value: ethers.utils.parseEther(contractInfo.cost),
      })
      .then((tx) => {
        console.log(tx);
        //action prior to transaction being mined
        provider.waitForTransaction(tx.hash).then(() => {
          //action after transaction is mined
          console.log(`Transaction hash: ${tx.hash}`);
          fetchTransaction(tx.hash);
          settxStatus("completed");
          handleSubmit();
          // (async (tx) => {
          //   const receipt = await tx.wait();
          //   console.log(
          //     `Transaction confirmed in block ${receipt.blockNumber}`
          //   );
          //   console.log(`Gas used: ${receipt.gasUsed.toString()}`);
          // })();
        });
      })
      .catch(() => {
        console.log("tx rejected");
        settxStatus("rejected");
        setError("Transaction rejected.");
      });
  };

  return (
    <div>
      <div id="wrapper">
        {/* header begin  */}
        <Navbar />
        {/* header close  */}

        {/* content begin  */}
        <div className="no-bottom no-top" id="content">
          <div id="top"></div>

          {/* about */}
          <section aria-label="section" style={{ background: "#000000" }}>
            <div className="container">
              <div className="spacer-single"></div>
              <div className="row justify-content-center">
                <div className="col-xl-5 col-lg-6 col-md-9 text-center">
                  <div>
                    <img
                      src="images/tiger_art/Tiger2.png"
                      height="200px"
                      width="200px"
                      className="about_token_img"
                      alt=""
                    />
                  </div>
                  <br />
                  <h2 className="about_h2">Mint Billionaire tigers</h2>
                  <p>
                    Earn Passive Income- Our brilliant NFT’s not only look
                    absolutely incredible but they also produce tiger tokens
                    every single week with our staking opportunities.{" "}
                  </p>
                  {contractInfo.totalSupply !== "" && (
                    <h3 style={{ margin: 0 }}>
                      {String(contractInfo.totalSupply)}/
                      {String(contractInfo.maxSupply)}
                    </h3>
                  )}
                  <div className="spacer-single"></div>
                  {/* <button className="btn btn-main">Mint Now</button> */}
                  {(txStatus === "completed" ||
                    txStatus === "" ||
                    txStatus === "rejected") && (
                    <button className="btn btn-main" onClick={mintToken}>
                      Mint Now
                    </button>
                  )}
                  {error !== "" && error !== 1 && (
                    <div style={{ color: "#dc3545" }}>{error}</div>
                  )}
                  {txStatus === "processing" && txStatus !== "" && (
                    <img
                      src="images/loading.gif"
                      height="80px"
                      alt="Loader gif"
                    />
                  )}

                  {error === 1 && (
                    <div style={{ color: "red", marginTop: "8px" }}>
                      Transaction failed.
                      <a
                        href={"https://rinkeby.etherscan.io/tx/" + tx}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "blue" }}
                      >
                        Please follow this link
                      </a>
                      to view in detail.
                    </div>
                  )}
                  {/* <table className="table w-full d-none">
                        <tbody>
                            <tr>
                            <th>{contractInfo.tokenName}</th>
                            <td>{contractInfo.tokenSymbol}</td>
                            <td>{String(contractInfo.totalSupply)}</td>
                            <td>{String(contractInfo.maxSupply)}</td>
                            <td>{contractInfo.deployedAt}</td>
                            </tr>
                        </tbody>
                    </table> */}
                </div>
              </div>
            </div>
          </section>
          {/* about */}
        </div>
        {/* content close  */}
        <Link to="/" id="back-to-top"></Link>
      </div>

      {/* footer begin  */}
      <Footer />
      {/* footer close */}
    </div>
  );
}
export default Mint;
